import { isPersianLocale } from './formatNumber';

export const PERSIAN_UI_FONT_FAMILY =
  'Vazirmatn, Tahoma, "Segoe UI", Arial, sans-serif';

export const DEFAULT_UI_FONT_FAMILY = 'Inter, "Segoe UI", Arial, sans-serif';

export const getUserInterfaceFontFamily = () =>
  isPersianLocale() ? PERSIAN_UI_FONT_FAMILY : DEFAULT_UI_FONT_FAMILY;
